import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { Alert } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './Section.css';

function Section (props) {
  return (
    <section
      className={`${props.customClass ? props.customClass : ''} turing-ui-v2-section ${props.backgroundColor ? 'turing-ui-v2-section-bg' : ''}`}
      style={{ padding: props.padding || 30 }}
    >
      {props.children}
    </section>
  );
}

Section.Separator = React.memo((props) => (
  <div className="turing-ui-v2-section-separator"></div>
));
Section.Center = React.memo((props) => (
  <div className="turing-ui-v2-section-center">{props.children}</div>
));
Section.Title = React.memo((props) => (
  <div className="turing-ui-v2-section-title">{props.children}</div>
));
Section.Grid = React.memo((props) => (
  <div className={`turing-ui-v2-section${props.inline ? '-inline' : ''}-grid`}>{props.children}</div>
));
Section.Dot = React.memo((props) => (
  <div className="turing-ui-v2-section-dot">
    {props.number ? <span>{props.number}</span> : null} <p>{props.children}</p>
  </div>
));
Section.VerticalSpacing = React.memo((props) => (
  <div className="turing-ui-v2-section-vertical-spacing" style={{ height: props.size || 10 }} />
));

Section.Info = React.memo((props) => (
  <div className="turing-ui-v2-section-info"> {props.icon ? <span className="turing-ui-v2-section-info-icon">{props.icon}</span> : null}  <span className="turing-ui-v2-section-info-content">{props.children}</span></div>
));

Section.Editable = React.memo((props) => {
  return (
    <div className="turing-ui-v2-section-editable">
      <div className="turing-ui-v2-section-editable-content">{props.children}</div>
      <div className="turing-ui-v2-section-editable-btn">
        { props.showGuide && (
          <Alert message={props.guideText || 'Edit this section'} type='info' className='fadeInAndOut' closeText={<FontAwesomeIcon icon={faArrowRight} />} />
        )}
        {
          props.isReadOnly
            ? null
            : (
              <IconButton onClick={props.onEditClick}>
                <EditIcon />
              </IconButton>
            )
        }
      </div>
    </div>
  );
});

Section.SectionTitle = React.memo((props) => {
  return (
    <div>
      <h3 className='sectionTitle'>{props.children}</h3>
      { props.showGuide && (
        <Alert message={props.guideText || 'Edit this section'} type='info' className='fadeInAndOut floatInline' icon={<FontAwesomeIcon icon={faArrowLeft} />} showIcon />
      )}
    </div>
  );
});

Section.propTypes = {
  children: PropTypes.any,
  backgroundColor: PropTypes.bool,
  padding: PropTypes.number,
  customClass: PropTypes.string
};

Section.Center.propTypes = {
  children: PropTypes.any
};

Section.Title.propTypes = {
  children: PropTypes.any
};

Section.Grid.propTypes = {
  children: PropTypes.any,
  inline: PropTypes.bool
};

Section.Dot.propTypes = {
  children: PropTypes.any,
  number: PropTypes.any
};

Section.VerticalSpacing.propTypes = {
  children: PropTypes.any,
  size: PropTypes.any
};

Section.Info.propTypes = {
  children: PropTypes.any,
  icon: PropTypes.any
};

Section.Editable.propTypes = {
  children: PropTypes.any,
  onEditClick: PropTypes.func,
  showGuide: PropTypes.bool,
  isReadOnly: PropTypes.any,
  guideText: PropTypes.string
};

Section.SectionTitle.propTypes = {
  children: PropTypes.any,
  showGuide: PropTypes.bool,
  guideText: PropTypes.string
};

export default Section;
